(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ogk-sui-shared"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__suiSharedInit) return;
    window.__suiSharedInit = true;

    function initReveal() {
      var els = document.querySelectorAll('.sui-reveal');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < els.length; i++) els[i].classList.add('is-visible');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      for (var j = 0; j < els.length; j++) io.observe(els[j]);
    }

    function boot() {
      // テーマエディタ編集中はアニメで隠さない（再描画でプレビューが空白になるのを防ぐ）
      if (window.Shopify && window.Shopify.designMode) return;
      // JS有効時のみ reveal を隠す（no-JSでは常に表示）
      document.documentElement.classList.add('sui-anim');
      initReveal();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
